// src/components/ReactionPicker.js

import React from 'react';
import { Paper, IconButton } from '@mui/material';

const REACTIONS = ['👍', '❤️', '😂', '😮', '😢', '🙏'];

const ReactionPicker = ({ onSelectReaction }) => {
  return (
    <Paper sx={{ p: 0.5, display: 'flex', gap: 0.5 }}>
      {REACTIONS.map(emoji => (
        <IconButton key={emoji} onClick={() => onSelectReaction(emoji)} size="small">
          <span style={{ fontSize: '1.2rem' }}>{emoji}</span>
        </IconButton>
      ))}
    </Paper>
  );
};

export default ReactionPicker;